import React from "react";
import { Link } from "react-router-dom";

const UnauthorisedPage = () => {
    return (
        <div>
            <h1>Unauthorised</h1>
            <p>You don&apos;t have permission to view this page.</p>
            <Link to="/">Go back to Home</Link>
        </div>
    );
};

export default UnauthorisedPage;
